var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.merchantInfo?.merchantStatus || _vm.checkMerchant)?_c('div',{class:{
    buyCryptoMerchant: _vm.merchantInfo?.merchantStatus,
    sellCryptoMerchant: _vm.checkMerchant,
  },staticStyle:{"display":"none"},attrs:{"id":"ValidMerchantTag"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }